import { TableColumnDef } from '../../../utils/tableColumns';
import { MemberSortField } from '../types';

export type DischargedColumnId =
    | 'member'
    | 'patientId'
    | 'memberSince'
    | 'device'
    | 'dischargeDate'
    | 'careManager'
    | 'reason'
    | 'status'
    | 'finalizedDate'
    | 'role';

/**
 * Single source of truth for the Discharged members list columns. Sorting runs on the same
 * `enterprise/members` endpoint as the active list, so the same two columns are sortable — the
 * discharge and finalized dates are not fields it can sort by.
 */
export const DISCHARGED_COLUMNS: TableColumnDef<DischargedColumnId, MemberSortField>[] = [
    { id: 'member', label: 'Member', size: '3.5fr', alwaysVisible: true, sortField: 'last_name' },
    { id: 'patientId', label: 'Patient ID', size: '1.5fr', defaultVisible: false },
    {
        id: 'memberSince',
        label: 'Member since',
        size: '1.8fr',
        defaultVisible: false,
        sortField: 'activated_at'
    },
    { id: 'device', label: 'Device ID', size: '1.8fr', defaultVisible: false },
    { id: 'dischargeDate', label: 'Discharge Date', size: '2fr' },
    { id: 'careManager', label: 'Care Manager', size: '2.4fr' },
    { id: 'reason', label: 'Reason', size: '3fr' },
    { id: 'status', label: 'Status', size: '2fr' },
    { id: 'finalizedDate', label: 'Finalized Date', size: '1.5fr' },
    { id: 'role', label: 'Role', size: '2.2fr', defaultVisible: false }
];

export const DISCHARGED_COLUMNS_STORAGE_KEY = 'ep:columns:discharged-members';
